import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["themeColor", "children"];
// @ts-expect-error types missing
import getBestContrastColor from 'feedback-utils/bestContrastColor';
import styled from 'foundations-theming/utils';
// @ts-expect-error types missing
import { Selectors } from '../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const BLACK = '#000000';
const WHITE = '#FFFFFF';
const StyledButton = styled.button.withConfig({
  displayName: "SubmitButton__StyledButton"
})(({
  theme,
  backgroundColor,
  textColor
}) => `
  background-color: ${backgroundColor};
  color: ${textColor};

  font-family:  ${theme.typography['detail-100'].fontFamily};
  cursor: pointer;
  display: inline-block;
  font-weight: ${theme.typography['detail-100'].fontWeight};
  line-height: ${theme.typography['detail-100'].lineHeight};
  font-size: ${theme.typography['detail-100'].fontSize};
  position: relative;
  text-align: center;
  transition: all 0.15s linear;
  border-radius: ${theme.borderRadius['100']};
  border-style: none;
  padding: ${theme.space['200']} ${theme.space['400']};

  &:disabled {
    background-color: ${theme.color['fill-primary-disabled']};
    border-color: ${theme.color['fill-primary-disabled']};
    color: ${theme.color['text-primary-disabled']};
    cursor: not-allowed;
}
`);
const SubmitButton = _ref => {
  let {
      themeColor,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const contrastColor = getBestContrastColor(themeColor);
  const isWhiteTheme = themeColor.toUpperCase() === WHITE;
  const backgroundColor = isWhiteTheme ? BLACK : themeColor;
  const textColor = isWhiteTheme ? WHITE : contrastColor;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledButton, Object.assign({
      id: "button",
      "data-selenium-test": Selectors.SUBMIT_BUTTON,
      backgroundColor: backgroundColor,
      textColor: textColor
    }, props, {
      children: children
    }))
  );
};
export default SubmitButton;